var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"section-title"},[_c('base-section-title',{attrs:{"title":"项目信息"}})],1),_c('div',{staticClass:"section-content"},[_c('jczh-descriptions',{attrs:{"info":_vm.detailInfo,"option":_vm.detailConfig,"el-attrs":{
          size: 'medium',
          labelStyle: {
            whiteSpace: 'nowrap'
          }
        }},scopedSlots:_vm._u([{key:"budget",fn:function(ref){
        var value = ref.value;
return [_c('span',[_vm._v(_vm._s(_vm.strToThousands(value || '-')))]),_c('span',{staticClass:"m-l-10"},[_vm._v("万元")]),_c('money-in-cn',{staticClass:"m-l-10",attrs:{"money":value * 10000}})]}},{key:"upload",fn:function(ref){
        var value = ref.value;
return [(value)?_c('upload',{attrs:{"group-id-before":value,"props-data":{
              disabled: true
            }}}):_c('span',[_vm._v("-")])]}}])})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }